/** Reads the relay's current head sequence (GET /info → headSeq) — the anchor for a
 *  bounded recent firehose backfill. Read-only. Returns 0 if the field is absent. */
export async function relayHeadSeq(baseUrl: string, fetchImpl?: typeof fetch): Promise<number> {
  const f = fetchImpl ?? globalThis.fetch.bind(globalThis);
  const res = await f(`${baseUrl}/info`);
  if (!res.ok) throw new Error(`relay /info failed: ${res.status} ${res.statusText}`);
  const body = (await res.json()) as { headSeq?: number };
  return typeof body.headSeq === "number" ? body.headSeq : 0;
}
